import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { KidProvider } from "@/context/KidContext";
import { Toaster } from "sonner";

import AppHeader from "@/components/AppHeader";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import SubscriptionRequired from "@/pages/SubscriptionRequired";
import Activate from "@/pages/Activate";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import HomeApp from "@/pages/HomeApp";
import Library from "@/pages/Library";
import ContentDetail from "@/pages/ContentDetail";
import Favorites from "@/pages/Favorites";
import Passport from "@/pages/Passport";
import Family from "@/pages/Family";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Series from "@/pages/Series";
import SeriesDetail from "@/pages/SeriesDetail";
import Journeys from "@/pages/Journeys";
import JourneyDetail from "@/pages/JourneyDetail";
import Onboarding from "@/pages/Onboarding";
import ParentsDashboard from "@/pages/ParentsDashboard";

function Layout() {
  return (
    <>
      <AppHeader />
      <Outlet />
      <Toaster position="top-right" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <KidProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<SubscriptionRequired />} />
                <Route path="/assinatura" element={<SubscriptionRequired />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/activate" element={<Activate />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                <Route path="/app" element={<ProtectedRoute><HomeApp /></ProtectedRoute>} />
                <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
                <Route path="/series" element={<ProtectedRoute><Series /></ProtectedRoute>} />
                <Route path="/series/:key" element={<ProtectedRoute><SeriesDetail /></ProtectedRoute>} />
                <Route path="/journeys" element={<ProtectedRoute><Journeys /></ProtectedRoute>} />
                <Route path="/journeys/:key" element={<ProtectedRoute><JourneyDetail /></ProtectedRoute>} />
                <Route path="/parents" element={<ProtectedRoute><ParentsDashboard /></ProtectedRoute>} />
                <Route path="/content/:id" element={<ProtectedRoute><ContentDetail /></ProtectedRoute>} />
                <Route path="/favorites" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
                <Route path="/passport" element={<ProtectedRoute><Passport /></ProtectedRoute>} />
                <Route path="/family" element={<ProtectedRoute><Family /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              </Route>
            </Routes>
          </KidProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
